function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#F6D5D5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.2778 10H12.7222C11.5 10 10.5111 11 10.5111 12.2222L10.5 27.7778C10.5 29 11.5 30 12.7222 30H28.2778C29.5 30 30.5 29 30.5 27.7778V12.2222C30.5 11 29.5 10 28.2778 10ZM28.2777 27.7778H12.7222V12.2222H28.2777V27.7778ZM22.1667 25.5556H18.8334V21.6667H14.9445V18.3333H18.8334V14.4445H22.1667V18.3333H26.0556V21.6667H22.1667V25.5556Z",
  fill: "#121221"
});

function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.1138fe45.svg";
export { ForwardRef as ReactComponent };